import React from 'react';
import PropTypes from 'prop-types';

const Close = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12.5 12.5">
    <path
      d="M-4.391-7.5l4.208-4.208a.624.624,0,0,0,0-.882l-.978-.978a.624.624,0,0,0-.882,0L-6.25-9.359l-4.208-4.208a.624.624,0,0,0-.882,0l-.977.977a.624.624,0,0,0,0,.882L-8.109-7.5l-4.208,4.208a.624.624,0,0,0,0,.882l.978.978a.624.624,0,0,0,.882,0L-6.25-5.641l4.208,4.208a.624.624,0,0,0,.882,0l.978-.978a.624.624,0,0,0,0-.882Z"
      transform="translate(12.5 13.75)"
      fill={color}
    />
  </svg>
);

Close.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Close.defaultProps = {
  width: 12.5,
  height: 12.5,
  color: '#d94141',
};

export default Close;
